<template>
  <div v-bind:class="{'flexible-content': (ai !== 0 && ai !== 4) }">
    <!--Navbar-->
    <navbar class="flexible-navbar white" v-bind:class="{'pl-0': ai === 0}" position="top" name="Infotronic" href="#" scrolling>
    <navbar-collapse>
      <navbar-nav left class="ml-2">
        <navbar-item>
        <img src="./assets/STGlogo.png" alt="STG logo" style="width: 70px; height: 45px">
      </navbar-item>
       <navbar-item v-if="!mng">
           <btn class="btn-call" size="sm"  outline="primary"><a href="tel:+995-577-063906">
                    <i class="fas fa-phone fa-lg"></i> +995-577-063906</a>
           </btn>
          </navbar-item>
      </navbar-nav>
        <navbar-nav left>
         <navbar-item v-if="mng && ai !== 9 && ai !== 7 && contragents.length > 0" class="d-flex" style="width: 250px;">
          <select v-model="selectedContragent" @change="selectContragent($event)" class="form-control custom-select" id="inputGroupSelect01">
            <template v-for="(contragent, index) in contragents">
              <option :key="index" :value="contragent.Ref_Key">{{contragent.Description}}</option>
            </template>
          </select>
        </navbar-item>
         <navbar-item>
           <template v-if="loading" >
            <div class="d-flex justify-content-center">
             <circle8></circle8>
            </div>
          </template>
          </navbar-item>
            <router-link to="/catalog">
            <navbar-item v-if="lang === 'RU'" @click.native="chngai(1)" class="nav-link dark-grey-text font-weight-bold waves-effect waves-lightwaves-fixed hoverable" v-bind:class="{active: ai === 1}" title='Список товаров'><i class="fa fa-list-alt grey-text fa-lg"></i><span class="badge badge-pill badge-info" v-bind:class="{'animated slow infinite zoomIn':goods.length === 0}">{{goods.length}}</span></navbar-item>
            <navbar-item v-if="lang === 'EN'" @click.native="chngai(1)" class="nav-link dark-grey-text font-weight-bold waves-effect waves-lightwaves-fixed hoverable" v-bind:class="{active: ai === 1}" title='Product list'><i class="fa fa-list-alt grey-text fa-lg"></i><span class="badge badge-pill badge-info" v-bind:class="{'animated slow infinite zoomIn':goods.length === 0}">{{goods.length}}</span></navbar-item>
            <navbar-item v-if="lang === 'GE'" @click.native="chngai(1)" class="nav-link dark-grey-text font-weight-bold waves-effect waves-lightwaves-fixed hoverable" v-bind:class="{active: ai === 1}" title='პროდუქტის სია'><i class="fa fa-list-alt grey-text fa-lg"></i><span class="badge badge-pill badge-info" v-bind:class="{'animated slow infinite zoomIn':goods.length === 0}">{{goods.length}}</span></navbar-item>
          </router-link>
          <router-link to="/information">
            <navbar-item v-if="false" class="nav-link dark-grey-text font-weight-bold waves-effect waves-lightwaves-fixed hoverable" v-bind:class="{ active: ai === 4 }" title=" Полезная информация, справочники " @click.native="chngai(4)"><i class="fas fa-info-circle fa-lg grey-text"></i> </navbar-item>
          </router-link>
          <navbar-item v-if="authorized && ai !== 7 && ai !== 9" class="nav-link dark-grey-text font-weight-bold waves-effect waves-lightwaves-fixed hoverable" v-bind:class="{ active: ai === 3 }" title=" Взаиморасчеты " @click.native="showModal = true"> <i class="fas fa-money-check-alt fa-lg grey-text"> </i> <span v-if="просроченныйДолг > 0" class="badge badge-pill badge-danger"> {{просроченныйДолг}} </span></navbar-item>
          <template v-if="goods.length > 0">
            <navbar-item v-if="lang === 'RU'" class="nav-link dark-grey-text font-weight-bold waves-effect waves-lightwaves-fixed hoverable" v-bind:class="{ active: ai === 2 }" title=" Корзина " @click.native="showBasket = true"><i class="fas fa-cart-arrow-down grey-text fa-lg"> </i><span class="badge badge-pill badge-info">{{ oi }}</span></navbar-item>
            <navbar-item v-if="lang === 'EN'" class="nav-link dark-grey-text font-weight-bold waves-effect waves-lightwaves-fixed hoverable" v-bind:class="{ active: ai === 2 }" title=" Basket " @click.native="showBasket = true"><i class="fas fa-cart-arrow-down grey-text fa-lg"> </i><span class="badge badge-pill badge-info">{{ oi }}</span></navbar-item>
            <navbar-item v-if="lang === 'GE'" class="nav-link dark-grey-text font-weight-bold waves-effect waves-lightwaves-fixed hoverable" v-bind:class="{ active: ai === 2 }" title=" კალათა " @click.native="showBasket = true"><i class="fas fa-cart-arrow-down grey-text fa-lg"> </i><span class="badge badge-pill badge-info">{{ oi }}</span></navbar-item>
          </template>
          </navbar-nav>
         <navbar-nav right>
         <router-link to="/sales">
          <navbar-item v-if="mng && salesReady && ai !== 9" class="nav-link dark-grey-text font-weight-bold waves-effect waves-lightwaves-fixed hoverable" v-bind:class="{ active: ai === 7 }" title=" Продажи" @click.native="chngai(7)"><i class="fas fa-chart-area red-text fa-lg"></i></navbar-item>
         </router-link>
         <router-link to="/order">
            <navbar-item @click.native="chngai(9)" v-if="mng && !hidebasket" class="nav-link dark-grey-text font-weight-bold waves-effect waves-lightwaves-fixed hoverable" v-bind:class="{ active: ai === 9 }" title=" Заказ товара "><i class="fas fa-truck red-text fa-lg"></i></navbar-item>
           </router-link>
           <navbar-item @click.native="lang = 'GE'" v-bind:class="{ active: lang === 'GE' }" class="nav-link dark-grey-text font-weight-bold waves-effect waves-lightwaves-fixed hoverable"><small>GE</small></navbar-item>
           <navbar-item @click.native="lang = 'EN'" v-bind:class="{ active: lang === 'EN' }" class="nav-link dark-grey-text font-weight-bold waves-effect waves-lightwaves-fixed hoverable"><small>EN</small></navbar-item>
           <navbar-item @click.native="lang = 'RU'" v-bind:class="{ active: lang === 'RU' }" class="nav-link dark-grey-text font-weight-bold waves-effect waves-lightwaves-fixed hoverable"><small>RU</small></navbar-item>
          <login @logoff="logoff()" :mng="mng" :lang="lang" :authorized="authorized" @auth="firstLogin($event)"></login>
         </navbar-nav>
      </navbar-collapse>
    </navbar>
    <!--/.Navbar-->
     <template>
         <!-- Sidebar -->
          <sidebar v-if="(ai != 4)" @CreateSupplierOrder="CreateSupplierOrder()" @selectScheme = "selectScheme($event)" :deliverySchemes='deliverySchemes' @changeordered="orderedOnly = !orderedOnly" @DateSelected="DateSelected($event)" @selectManager="selectManager($event)" :contragents="contragents" :activeMng="activeMng"  @folder0="getFolder0($event)" @folder1="getFolder1($event)"  @folder2="getFolder2($event)" :selectedManager='selectedManager' :lang="lang" :folders="folders" :mng="mng" :authorized="authorized" :ai="ai"></sidebar>
          <!-- /Sidebar  -->
       <main>
          <div class="p-5 mt-5">
            <modal v-if="mng && chatReady" removeBackdrop position="top-right">
                  <chat></chat>
            </modal>
          <template v-if="showBasket === true">
            <basket :lang = 'lang' :просроченныйДолг = 'просроченныйДолг' :долг = 'долг' :showBasket='showBasket' :goods='goods' :orders='orders' :activeOrder='activeOrder' :user='user' :comment='comment'  :goodsInfotronic='goodsInfotronic' @basket="basketUpdate" @closeBasket='showBasket = false' @addGood="addGood($event)"></basket>
          </template>
          <template v-if="showCRM === true">
            <CRM :selectedContragentDescription = "selectedContragentDescription" :partnerSalesByGroupsExport="partnerSalesByGroupsExport" @hideCRM="showCRM = false" :showCRM='showCRM' :goods='goods' :authorized='authorized' :user='user' :orders='orders' :mng='mng' :накладные='накладные' :partnerABCXYZ='partnerABCXYZ' :partnerSalesTotal='partnerSalesTotal' :partnerSales='partnerSales' :partnerSalesByGoodsExport='partnerSalesByGoodsExport'></CRM>
          </template>
          <router-view @orderCreated="orderCreated()" :supplierOrder="supplierOrder" :selectedSchema="selectedSchema" :deliverySchemes="deliverySchemes" :orderedOnly="orderedOnly" :salesReady="salesReady" @salesDestroy="selectContragent($event)" :startDate="startDate" :endDate="endDate" :rate="rate" :partnersSalesByPeriod="partnersSalesByPeriod" @infoContragent ="infoContragent($event)" :selectedManager="selectedManager" :contragents="contragents" :partnerSalesByGoodsExport="partnerSalesByGoodsExport" :lang="lang" :folder0="folder0" :folder1="folder1" :folder2="folder2" :partnerSales="partnerSales" :partnersABCXYZ="partnersABCXYZ" :partnerABCXYZ="partnerABCXYZ" :user="user" :acti="ai" :authorized="authorized" :mng="mng" :comment="comment" :orderedItems="orderedItems()" :activeOrder="activeOrder" :goods="goods" :накладные="накладные" :goodsInfotronic="goodsInfotronic" :orders="orders" @orderUpdated="getOrderList()" @addGood="addGood($event)" @auth="authorization($event)" ></router-view>
           <ftr color="grey" class="text-center font-small z-depth-1 ">
            <p class="footer-copyright mb-0 py-2 text-center white-text"> Akaki Tsereteli Ave 2, 0112 Tbilisi Тел <a href="tel:+995 577 063906 "> +995 577 063906 </a><a href="mailto:sofia@st-georgia.ge"> sofia@st-georgia.ge</a></p>
            <p class="footer-copyright mb-0 py-2 text-center black-text">
              &copy; {{new Date().getFullYear()}} Copyright: <a href="http://st-georgia.ge"> ST Georgia </a>
           </p>
          </ftr>
        </div>
       <modal position="bottom" size="lg" v-if="showModal" @close="showModal = false">
          <modal-header>
            <modal-title>{{ selectedContragentDescription }}</modal-title>
          </modal-header>
          <modal-body v-if="просроченныйДолг === 0" class="col-md-12 text-center">
            Условия оплаты: <b>отсрочка {{ отсрочка }} дней</b>. Общий долг: <b>{{долг}} BYN</b> Просроченный: <b>{{просроченныйДолг}} BYN</b>
          </modal-body>
          <modal-body v-if="просроченныйДолг > 0" class="col-md-12 text-center">
            Условия оплаты: отсрочка {{ отсрочка }} дней. Общий долг: <b>{{долг}} BYN</b> Просроченный: <b>
              <font color="red">{{просроченныйДолг}} BYN</font>
            </b>
          </modal-body>
          <modal-body>
            <template>
              <div>
                <tbl responsive>
                  <tbl-head color="primary-color" textWhite>
                    <tr>
                      <th>№</th>
                      <th>Дата</th>
                      <th>Сумма к оплате</th>
                      <th>Дней после отгрузки</th>
                      <th>Дней до оплаты</th>
                    </tr>
                  </tbl-head>
                  <tbl-body v-if="долг>0" v-for="(накладная, index) in накладные" :key="index">
                    <tr>
                      <th scope="row">{{накладная.НомерДокумента}}</th>
                      <td>{{накладная.Date | moment("DD-MM-YYYY")}}</td>
                      <td v-if="накладная.ДнейДоОплаты > 0">{{ Math.round(накладная.Неоплачено * 100) / 100 }}</td>
                      <td v-if="накладная.ДнейДоОплаты < 0"><b>
                          <font color="red">{{Math.round(накладная.Неоплачено * 100) / 100}}</font>
                        </b></td>
                      <td>{{накладная.ДнейПослеОтгрузки}}</td>
                      <td v-if="накладная.ДнейДоОплаты > 0">{{накладная.ДнейДоОплаты}}</td>
                      <td v-if="накладная.ДнейДоОплаты < 0"><b>
                          <font color="red">{{накладная.ДнейДоОплаты}}</font>
                        </b></td>
                    </tr>
                  </tbl-body>
                </tbl>
              </div>
            </template>
           </modal-body>
          <modal-footer class="d-flex justify-content-around">
            <a class="logo-wrapper animated slow fadeIn" title="Учусь )"><img alt="Tronic" class="img-fluid" src="./assets/ai50.png"></a>
            <btn color="primary" @click.native="showModal = false">Закрыть</btn>
          </modal-footer>
        </modal>
       </main>
    </template>
  </div>
</template>
<script>
import {
  Badge,
  Container,
  Navbar,
  NavbarItem,
  NavbarNav,
  NavbarCollapse,
  Btn,
  Fa,
  ListGroup,
  ListGroupItem,
  CardBody,
  Footer,
  waves,
  Modal,
  ModalHeader,
  ModalTitle,
  ModalBody,
  ModalFooter,
  Tooltip,
  Popover,
  MdTextarea,
  Row,
  Column,
  Tbl,
  TblHead,
  TblBody,
  Carousel,
  CarouselItem,
  CarouselCaption
} from 'mdbvue'
import Catalog from './components/Catalog'
import Basket from './components/Basket'
import CRM from './components/CRM'
import Login from './components/Login'
import Sales from './components/Sales'
import Order from './components/Order'
import Chat from './components/Chat'
// import Sidebar from './components/Sidebar'
import ApiService from '@/services/ApiService'
import format from 'date-fns/format'
import addDays from 'date-fns/add_days'
import subDays from 'date-fns/sub_days'
import axios from 'axios'
import {
  Circle8
} from 'vue-loading-spinner'

export default {
  name: 'B2BTemplate',
  components: {
    Badge,
    Container,
    Navbar,
    NavbarItem,
    NavbarNav,
    NavbarCollapse,
    Btn,
    ListGroup,
    ListGroupItem,
    Fa,
    CardBody,
    'ftr': Footer,
    Catalog,
    Basket,
    Sales,
    Modal,
    ModalHeader,
    ModalTitle,
    ModalBody,
    ModalFooter,
    Tooltip,
    Popover,
    MdTextarea,
    Row,
    Column,
    Tbl,
    TblHead,
    TblBody,
    Circle8,
    Login,
    Chat,
    CRM,
    Order,
    Carousel,
    CarouselItem,
    CarouselCaption
  },
  data () {
    return {
      orderedOnly: true,
      lang: 'GE',
      deliverySchemes: [],
      selectedSchema: '09575470-60c2-11e7-ac65-001dd8b723ef',
      activeItem: 1,
      activeOrder: 0,
      salesReady: false,
      orderReady: false,
      chatReady: false,
      supplierOrder: false,
      ai: 1,
      oi: 0,
      info: null,
      updatedChart: false,
      oldReserves: 0,
      loading: false,
      authorized: false,
      mng: false,
      rate: 1,
      managers: [],
      activeMng: [],
      selectedManager: '00000000-0000-0000-0000-000000000000',
      order: [],
      orders: [],
      goods: [],
      contragents: [],
      businessRegions: [],
      selectedContragentDescription: '',
      selectedContragent: '',
      selectedPartner: '',
      selectedPartnerAnalytics: '',
      goodsInfotronic: [],
      startDate: '',
      endDate: '',
      user: '',
      partnerABCXYZ: [],
      partnersABCXYZ: [],
      comment: '',
      долг: 0,
      просроченныйДолг: 0,
      непросроченныйДолг: 0,
      отсрочка: 0,
      накладные: [],
      showModal: false,
      sideClosed: false,
      bbIndex: 0,
      showBasket: false,
      showCRM: false,
      folders: [],
      // partnerSales2017: [],
      partnerSales: [],
      partnersSales: [],
      partnerSalesTotal: [],
      partnersSalesByGoods: [],
      partnerSalesByGoods: [],
      partnerSalesByGoodsExport: [],
      partnerSalesByGroups: [],
      partnerSalesByGroupsExport: [],
      partnersSalesByPeriod: [],
      partnersSalesByPeriodShort: [],
      folder0: '00000000-0000-0000-0000-000000000000',
      folder1: '00000000-0000-0000-0000-000000000000',
      folder2: '00000000-0000-0000-0000-000000000000',
      hidebasket: true
    }
  },
  methods: {
    orderCreated () {
      this.supplierOrder = false
    },
    async mngProcedures () {
      console.log('mngProcedures')
      // this.checkip()
      this.exchangeRate()
      this.authorized = true
      this.getDeliverySchemes()
      this.getPartnersSalesPeriodShort()
      this.getPartnersSalesByYearByGoods()
      this.getContragents()
      this.getManagers()
      this.getPartnersSalesByYear()
      this.mng = true
      this.getPartnerABCXYZ(this.selectedPartner)
      this.copyOrderToBasket()
      event.dateone = subDays(Date(), 7)
      event.datetwo = addDays(Date(), 0)
      this.DateSelected(event)
    },
    logoff () {
      console.log('logoff')
      this.authorized = false
      this.mng = false
    },
    async getDeliverySchemes () {
      console.log('getDeliverySchemes')
      let answer = await ApiService.getDeliverySchemes()
      this.deliverySchemes = answer.data.value
      this.deliverySchemes[this.deliverySchemes.length] = {'Description': 'Заказ глобальный', 'Ref_Key': '00000000-0000-0000-0000-000000000000'}
      // this.deliverySchemes[this.deliverySchemes.length]['Description'] = 'Заказ поставщикам Skorpiono'
      // this.deliverySchemes[this.deliverySchemes.length]['Ref_Key'] = '00000000-0000-0000-0000-000000000000'
      console.log(this.deliverySchemes[this.deliverySchemes.length - 1])
    },
    getFolder0 (event) {
      // console.log(event)
      this.folder0 = event
    },
    getFolder1 (event) {
      // console.log(event)
      this.folder1 = event
    },
    getFolder2 (event) {
      // console.log(event)
      this.folder2 = event
    },
    chngai: function (e) {
      console.log(e)
      this.ai = e
    },
    async selectScheme (event) {
      console.log('selectScheme ' + event)
      await this.goods.forEach((good) => {
        good.toOrder = ''
      })
      this.selectedSchema = event
    },
    async selectContragent (event) {
      // this.loading = true
      // console.log(event)
      var contragent = ''
      if (event === undefined) contragent = this.selectedContragent
      else contragent = event.target.value
      this.hidebasket = true
      console.log('Change contragent ' + contragent)
      this.selectedContragent = contragent
      var uid = this.selectedContragent
      let response = await ApiService.auth(uid)
      if (response.data !== 'Auth ERROR') {
        if (response.data.value[0]['Контрагент_Key'] === uid) {
          console.log('user true')
          let data = response.data
          this.user = data.value[0]
          this.authorized = true
          this.selectedContragent = this.user.Контрагент_Key
          this.selectedContragentDescription = this.user.Наименование
          this.selectedPartner = this.user.КлючАналитикиПартнера
          this.selectedPartnerAnalytics = this.user.Партнер_Key
          this.$localStorage.set('UID', this.selectedContragent)
          this.$localStorage.set('Description', this.selectedContragentDescription)
          this.getGoods(this.user.Контрагент_Key)
          this.getSkorpionoGoods(this.user.Контрагент_Key)
          this.getOrderList()
          this.getClientBalance()
          this.copyOrderToBasket()
        }
      }
    },
    async DateSelected (event) {
      // console.log(event)
      this.startDate = event.dateone
      this.endDate = event.datetwo
      if (event.dateone === '') event.dateone = event.datetwo
      const response = await ApiService.partnersSalesByPeriod(event.dateone, addDays(event.datetwo, 1))
      let data = response.data
      this.partnersSalesByPeriod = data.value
      // console.log(data.value)
    },
    async exchangeRate () {
      const response = await ApiService.getExchangeRate()
      let data = response.data
      this.rate = data.value[0].Курс
    },
    async CreateSupplierOrder () {
      console.log('CreateSupplierOrder - APP')
      this.supplierOrder = true
    },
    async infoContragent (event) {
      // console.log(event)
      // this.loading = true
      this.hidebasket = true
      console.log('Info contragent')
      // this.$bus.$emit('Contragent')
      // await this.auth(event)
      // console.log('from infocontragent, count ' + this.contragents.length)
      for (var i = 0; i < this.contragents.length; i++) {
        if (this.contragents[i].Ref_Key === event) {
          this.selectedContragent = this.contragents[i].Ref_Key
          this.selectedPartner = this.contragents[i].Партнер_Key
          this.selectedPartnerAnalytics = this.contragents[i].АналитикаУчетаПоПартнерам_Key
          this.selectedContragentDescription = this.contragents[i].Description
          break
        }
      }
      this.getPartnerSalesByYear(this.selectedPartnerAnalytics)
      this.getPartnerABCXYZ(this.selectedPartner)
      // this.$bus.$emit('partnerSalesByYear')
      this.getPartnerSalesByYearByGoods(this.selectedPartnerAnalytics)
      this.getPartnerSalesByYearByGroups(this.selectedPartnerAnalytics)
      this.showCRM = true
      this.$bus.$emit('Contragent')
      // this.auth(this.selectedContragent)
    },
    selectManager (event) {
      this.selectedManager = event.target.value
    },
    // Вызывается из Login
    async firstLogin (UID) {
      console.log('auth')
      if (UID === '00000000-0000-0000-0000-000000000000') return false
      const attempt = await this.loginContragent(UID)
      if (attempt) location.reload()
      if (!attempt) await this.loginMng(UID)
    },
    async loginContragent (UID) {
      console.log('loginContragent')
      if (UID === '00000000-0000-0000-0000-000000000000') return false
      const response = await ApiService.auth(UID)
      let data = response.data
      if (data !== 'Auth ERROR') {
        if (response.data.value[0]['Контрагент_Key'] === UID) {
          // console.log('USER ' + data)
          this.$localStorage.set('UID', data.value[0]['Контрагент_Key'])
          this.$localStorage.set('Description', data.value[0]['Наименование'])
          this.authorized = true
          return true
        }
      } else alert('Неверный идентификатор')
      return false
    },
    async loginMng (UID) {
      console.log('loginMng')
      if (UID === '00000000-0000-0000-0000-000000000000') return false
      this.mng = false
      this.checkip()
      var info = JSON.stringify(this.info)
      // console.log(info)
      const response = await ApiService.authMNG(UID, info)
      let data = response.data
      if (data !== 'Auth ERROR') {
        if (data.value[0]['Ref_Key'] === UID) {
          if (data.value[0]['Description'] === '<Не указан>') {
            alert('Неверный UID')
            this.$localStorage.remove('MNG')
            this.$localStorage.remove('DescriptionMNG')
            this.mng = false
            return false
          }
          console.log('MNG ')
          this.$localStorage.set('MNG', data.value[0]['Ref_Key'])
          this.$localStorage.set('DescriptionMNG', data.value[0]['Description'])
          this.$localStorage.set('UID', '1224b3a5-e75e-11e5-a13e-00e04d95380f')
          this.$localStorage.set('Description', 'РОЗНИЧНЫЙ КЛИЕНТ')
          this.authorized = true
          this.mng = true
          await this.mngProcedures()
          this.checkauth()
          return true
        }
      }
      return false
    },
    async checkip () {
      await axios.get('https://ipinfo.io/json').then(response => (this.info = response.data)).catch(error => console.log(error))
      this.info.MNG = this.$localStorage.get('MNG')
      this.info.DescriptionMNG = this.$localStorage.get('DescriptionMNG')
    },
    // Проверка на сервере
    async checkauth () {
      console.log('checkauth')
      var uid = this.$localStorage.get('UID', 'false')
      var mng = this.$localStorage.get('MNG', 'false')
      if (uid === 'false' && mng === 'false') {
        console.log('both false')
        return false
      }
      if (mng !== 'false' && uid !== 'false') {
        await this.checkip()
        var info = JSON.stringify(this.info)
        // console.log(info)
        let response = await ApiService.authMNG(mng, info)
        // console.log(response)
        if (response.data !== 'Auth ERROR') {
          if (response.data.value[0]['Ref_Key'] === mng) {
            console.log('mng true')
            this.selectedManager = mng
            this.mngProcedures()
          }
        }
      }
      if (uid !== 'false') {
        let response = await ApiService.auth(uid)
        // console.log(response.data)
        if (response.data !== 'Auth ERROR') {
          if (response.data.value[0]['Контрагент_Key'] === uid) {
            console.log('user true')
            let data = response.data
            this.user = data.value[0]
            this.authorized = true
            // this.showModal = false
            this.authorization(this.user)
            // this.$emit('auth', this.user)
          }
        }
      }
    },
    // Процедуры при загрузке клиента
    async authorization (event) {
      console.log('authorization')
      this.user = event
      this.selectedContragent = this.user.Контрагент_Key
      this.getGoods(this.user.Контрагент_Key)
      this.getSkorpionoGoods(this.user.Контрагент_Key)
      this.getOrderList()
      this.getClientBalance()
      if (this.mng) {
        this.mngProcedures()
      }
    },
    async getFolders () {
      console.log('folders')
      const response = await ApiService.getFolders()
      let data = response.data
      this.folders = data
      // console.log(response)
    },
    async getManagers () {
      console.log('managers')
      const response = await ApiService.managers()
      let data = response.data
      this.managers = data.value
    },
    orderedItems () {
      var tmp = this.$localStorage.get('order')
      // console.log(tmp)
      if (tmp !== null) {
        this.oi = JSON.parse(this.$localStorage.get('order', '')).length
      }
    },
    copyPrices () {
      console.log('CopyPrices ' + this.goods.length)
      this.goods.forEach((good) => {
        good.СхемаОбеспечения_Key = '09575470-60c2-11e7-ac65-001dd8b723ef'
        good.toOrder = ''
        good.changed = false
      })
      this.goodsInfotronic.forEach((good) => {
        for (var i = 0; i < this.goods.length; i++) {
          if (this.goods[i].Ref_Key === good.Ref_Key) {
            this.goods[i].Price = good.Price
            this.goods[i].СхемаОбеспечения_Key = good.СхемаОбеспечения_Key
            // console.log(this.goods[i].Price)
            break
          }
        }
      })
    },
    async getGoods (UID) {
      console.log('getGoods')
      // this.loading = true
      this.getFolders()
      const response = await ApiService.getGoods(UID)
      let data = response.data
      this.goods = data.value
      // this.goodsInfotronic = data.value
      var tmp = this.$localStorage.get('order')
      if (tmp !== null) {
        this.order = JSON.parse(this.$localStorage.get('order', ''))
        console.log('copy')
        this.goods.forEach((good) => {
          this.order.forEach((ordergood) => {
            if (ordergood.key === good.Ref_Key) {
              good.ConfirmedQty = ordergood.qty
              good.OrderedQty = ordergood.qty
              console.log(ordergood.qty)
            }
          })
        })
      }
    },
    async getPartnerABCXYZ (partnerKey) {
      this.partnerABCXYZ = []
      console.log('getPartnerABCXYZ - length ' + this.partnersABCXYZ.length)
      this.partnerABCXYZ = this.partnersABCXYZ.filter(partner => partner.Партнер_Key === partnerKey)
      // console.log(this.partnerABCXYZ)
    },
    async getPartnersSalesPeriodShort () {
      console.log('getPartnersSalesPeriodShort')
      for (var i = 0; i < 12; i++) {
        var startDate = format(subDays(Date(), 7 * i - 1 + 7), 'YYYY-MM-DD')
        var endDate = format(subDays(Date(), 7 * i - 1), 'YYYY-MM-DD')
        console.log(startDate + ' ' + endDate)
        const response = await ApiService.partnersSalesByPeriodShort(startDate, endDate)
        // console.log(response)
        let data = response.data
        this.partnersSalesByPeriodShort[i] = []
        this.partnersSalesByPeriodShort[i] = data.value
      }
    },
    addPartnerSalesShort () {
      console.log('this.contragents.length ' + this.contragents.length)
      console.log('this.partnersSalesByPeriodShort.length ' + this.partnersSalesByPeriodShort.length)
      this.contragents.forEach((contragent) => {
        contragent.shortSales = []
        for (var i = 0; i < 12; i++) {
          contragent.shortSales[i] = 0
          var shortSales = []
          shortSales = this.partnersSalesByPeriodShort[i].filter(partner => partner.АналитикаУчетаПоПартнерам_Key === contragent.АналитикаУчетаПоПартнерам_Key)
          if (shortSales.length > 0) {
            contragent.shortSales[i] = shortSales[0].СуммаВыручкиБезНДСTurnover
            // console.log('shortSales.length ' + shortSales.length)
          }
        }
      })
      this.salesReady = true
    },
    async getPartnersABCXYZ () {
      this.partnersABCXYZ = []
      // console.log('getPartnersABCXYZ')
      const response = await ApiService.partnersABCXYZ()
      // console.log(response)
      let data = response.data
      this.partnersABCXYZ = data.value
      console.log('getPartnersABCXYZ - contragents ' + this.contragents.length)
      var abc = []
      for (var i = 0; i < this.contragents.length; i++) {
        this.contragents[i].sales = 0
        this.contragents[i].class = 'UU'
        abc = this.partnersABCXYZ.filter(partner => partner.Партнер_Key === this.contragents[i].Партнер_Key)
        this.contragents[i].partnerABCXYZ = []
        this.contragents[i].partnerABCXYZ = abc
        if (this.contragents[i].partnerABCXYZ.length > 0) {
          this.contragents[i].sales = Math.round(this.contragents[i].partnerABCXYZ[0].ЗначениеПараметраКлассификации)
          var cl = ''
          const ABC = this.contragents[i].partnerABCXYZ
          // console.log(ABC)
          if (ABC.length === 0) cl = 'UU'
          else if (ABC[0].Класс === 'НеКлассифицирован') cl = 'U'
          else if (ABC[0].Класс === 'AКласс') cl = 'A'
          else if (ABC[0].Класс === 'BКласс') cl = 'B'
          else if (ABC[0].Класс === 'CКласс') cl = 'C'
          const XYZ = this.contragents[i].partnerABCXYZ
          // console.log(XYZ)
          if (XYZ.length === 0) cl = 'UU'
          else if (XYZ[1].Класс === 'НеКлассифицирован') cl = 'UU'
          else if (XYZ[1].Класс === 'XКласс') cl += 'X'
          else if (XYZ[1].Класс === 'YКласс') cl += 'Y'
          else if (XYZ[1].Класс === 'ZКласс') cl += 'Z'
          if (ABC.length > 0) this.contragents[i].class = cl
        }
      }
    },
    async getClientBalance () {
      // var uid = this.$localStorage.get('UID', 'false')
      console.log('Get client balance')
      // console.log('this.user.Контрагент_Key ' + this.user['Контрагент_Key'])
      // console.log(this.user.ЭтапыГрафикаОплаты[0].Сдвиг)
      const response = await ApiService.getClientBalance(this.user.Партнер_Key, this.user.ЭтапыГрафикаОплаты[0].Сдвиг)
      let data = response.data
      // console.log(data)
      this.накладные = data.value
      // console.log(data.value.length)
      this.долг = this.накладные[0].Долг
      this.просроченныйДолг = this.накладные[0].Просрочено
      if (this.просроченныйДолг < 0) this.просроченныйДолг = 0
      this.непросроченныйДолг = this.накладные[0].Непросрочено
      this.отсрочка = this.накладные[0].Отсрочка
    },
    async getSkorpionoGoods (UID) {
      console.log('getSkorpionoGoods')
      const response = await ApiService.getSkorpionoCatalog(UID)
      let data = response.data
      this.goods = data.value
      // console.log(response)
      if (this.authorized) await this.copyOrderToBasket()
    },
    async getBusinessRegions () {
      console.log('getBusinessRegions')
      let response = await ApiService.getBusinessRegions()
      this.businessRegions = response.data.value
    },
    businessregion (region) {
      var reg = ''
      var result = this.businessRegions.filter(br => br.Ref_Key === region)
      if (result.length > 0) {
        // console.log(result[0].Description)
        reg = result[0].Description
        if (result[0].Description !== '00000000-0000-0000-0000-000000000000') {
          result = this.businessRegions.filter(br => br.Ref_Key === result[0].Parent_Key)
          if (result.length > 0) {
            reg += ', ' + result[0].Description
            if (result[0].Description !== '00000000-0000-0000-0000-000000000000') {
              result = this.businessRegions.filter(br => br.Ref_Key === result[0].Parent_Key)
              if (result.length > 0) {
                reg += ', ' + result[0].Description
              }
            }
          }
        }
      }
      return reg
    },
    async getContragents () {
      console.log('getContragents')
      const response = await ApiService.getContragents()
      let data = response.data
      this.contragents = data.value
      for (var i = 0; i < this.contragents.length; i++) {
        if (this.contragents[i].Ref_Key === this.selectedContragent) {
          this.selectedPartner = this.contragents[i].Партнер_Key
          this.selectedPartnerAnalytics = this.contragents[i].АналитикаУчетаПоПартнерам_Key
          this.selectedContragentDescription = this.contragents[i].Description
          break
        }
      }
      console.log('this.contragents.length ' + this.contragents.length)
      for (i = 0; i < this.contragents.length; i++) {
        this.contragents[i].БизнесРегион = this.businessregion(this.contragents[i].БизнесРегион_Key)
        // console.log(this.businessregion(this.contragents[i].БизнесРегион_Key))
      }
      this.getPartnersABCXYZ()
      console.log('managers contragents' + this.managers.length)
      this.activeMng = []
      this.activeMng.push({Description: 'ВСЕ', Ref_Key: '00000000-0000-0000-0000-000000000000'})
      this.managers.forEach((manager) => {
        var active = []
        active = this.contragents.filter(contragent => contragent.ОсновнойМенеджер_Key === manager.Ref_Key)
        // console.log(active.length)
        if (active.length > 0) this.activeMng.push(manager)
      })
    },
    async getOrderList () {
      /*
      this.orders = []
      var ao = -1
      var uid = this.$localStorage.get('UID', 'false')
      const response = await ApiService.getOrderList(uid)
      let data = response.data
      // console.log(response)
      // console.log(this.user)
      // нет заказов совсем - создаем новый
      this.orders = data.value
      if (this.orders.length === 0) {
        this.createOrder()
        ao = 0
      } else {
        this.orders.forEach(function (order, index) {
          if (order.Статус === 'НеСогласован') {
            // console.log('Не согласован:' + index)
            ao = index
          }
        })
        if (ao === -1) {
          this.createOrder()
          ao = 0
        }
        this.activeOrder = ao
        this.oldcomment = this.orders[this.activeOrder].Комментарий
      }
      */
      // this.copyOrderToBasket()
    },
    async createOrder () {
      console.log('create order')
      var uid = this.$localStorage.get('UID', 'false')
      await ApiService.createOrder(this.user.Партнер_Key, this.user.Контрагент_Key, this.user.Ref_Key)
      this.getOrderList(uid)
      this.activeOrder = this.orders.length - 1
    },
    async getPartnersSalesByYear () {
      console.log('getPartnersSalesByYear')
      var date = new Date()
      var year = date.getFullYear().toString()
      const response0 = await ApiService.partnersSalesByYear(year)
      const response1 = await ApiService.partnersSalesByYear((year - 1))
      const response2 = await ApiService.partnersSalesByYear((year - 2))
      this.partnersSales[0] = response0.data
      this.partnersSales[1] = response1.data
      this.partnersSales[2] = response2.data
    },
    getPartnerSalesByYear (partnerAnalyticsKey) {
      console.log('getPartnerSalesByYear')
      var date = new Date()
      var month = date.getMonth()
      this.partnerSales[0] = []
      this.partnerSales[1] = []
      this.partnerSales[2] = []
      for (var i = 1; i <= month + 1; i++) {
        if (this.partnersSales[0][i][partnerAnalyticsKey] !== undefined) {
          this.partnerSales[0][i - 1] = this.partnersSales[0][i][partnerAnalyticsKey]
        } else this.partnerSales[0][i - 1] = 0
      }
      for (i = 1; i < 13; i++) {
        if (this.partnersSales[1][i][partnerAnalyticsKey] !== undefined) {
          this.partnerSales[1][i - 1] = this.partnersSales[1][i][partnerAnalyticsKey]
        } else this.partnerSales[1][i - 1] = 0
        if (this.partnersSales[2][i] !== undefined && this.partnersSales[2][i][partnerAnalyticsKey] !== undefined) {
          this.partnerSales[2][i - 1] = this.partnersSales[2][i][partnerAnalyticsKey]
        } else this.partnerSales[2][i - 1] = 0
      }
      var total0 = 0
      var total1 = 0
      var total2 = 0
      // console.log(month)
      this.partnerSalesTotal[0] = []
      this.partnerSalesTotal[1] = []
      this.partnerSalesTotal[2] = []
      for (i = 0; i < 12; i++) {
        this.partnerSalesTotal[0][i] = 0
        this.partnerSalesTotal[1][i] = 0
        this.partnerSalesTotal[2][i] = 0
      }
      for (i = 0; i <= month; i++) {
        total0 += Math.round(this.partnerSales[0][i])
        total1 += Math.round(this.partnerSales[1][i])
        total2 += Math.round(this.partnerSales[2][i])
        this.partnerSalesTotal[0][i] = total0
        this.partnerSalesTotal[1][i] = total1
        this.partnerSalesTotal[2][i] = total2
      }
    },
    async getPartnersSalesByYearByGoods () {
      console.log('getPartnersSalesByYearByGoods')
      var date = new Date()
      var year = date.getFullYear().toString()
      const response0 = await ApiService.partnersSalesByYearByGoods(year)
      const response1 = await ApiService.partnersSalesByYearByGoods((year - 1))
      const response2 = await ApiService.partnersSalesByYearByGoods((year - 2))
      this.partnersSalesByGoods[0] = response0.data
      this.partnersSalesByGoods[1] = response1.data
      this.partnersSalesByGoods[2] = response2.data
    },
    async getPartnerSalesByYearByGoods (partnerAnalyticsKey) {
      console.log('getPartnerSalesByYearByGoods')
      // var date = new Date()
      // var year = date.getFullYear().toString()
      // const response0 = await ApiService.partnerSalesByYearByGoods(this.user.КлючАналитикиПартнера, year)
      // const response1 = await ApiService.partnerSalesByYearByGoods(this.user.КлючАналитикиПартнера, (year - 1))
      // const response2 = await ApiService.partnerSalesByYearByGoods(this.user.КлючАналитикиПартнера, (year - 2))
      this.partnerSalesByGoods[0] = this.partnersSalesByGoods[0]['value'].filter(partner => partner.АналитикаУчетаПоПартнерам_Key === partnerAnalyticsKey)
      this.partnerSalesByGoods[1] = this.partnersSalesByGoods[1]['value'].filter(partner => partner.АналитикаУчетаПоПартнерам_Key === partnerAnalyticsKey)
      this.partnerSalesByGoods[2] = this.partnersSalesByGoods[2]['value'].filter(partner => partner.АналитикаУчетаПоПартнерам_Key === partnerAnalyticsKey)
      for (var i = 0; i < 3; i++) {
        this.partnerSalesByGoods[i].sort((a, b) => {
          if (a.СуммаВыручкиБезНДСTurnover < b.СуммаВыручкиБезНДСTurnover) {
            return 1
          }
          if (a.СуммаВыручкиБезНДСTurnover > b.СуммаВыручкиБезНДСTurnover) {
            return -1
          }
          // a должно быть равным b
          return 0
        })
      }
      var len = []
      len[0] = this.partnerSalesByGoods[0].length
      len[1] = this.partnerSalesByGoods[1].length
      len[2] = this.partnerSalesByGoods[2].length
      // console.log(len[0])
      // console.log(len[1])
      // console.log(len[2])
      for (var k = 0; k < 3; k++) {
        if (len[k] > 100) len[k] = 100
        this.partnerSalesByGoodsExport[k] = []
        for (i = 0; i < len[k]; i++) {
          this.partnerSalesByGoodsExport[k][i] = {}
          // this.partnerSalesByGoodsExport[k][i]['Себестоимость'] = this.partnerSalesByGoods[k].value[i].СтоимостьБезНДСTurnover
          // this.partnerSalesByGoodsExport[k][i]['Допрасходы'] = this.partnerSalesByGoods[k].value[i].ДопРасходыTurnover
          // this.partnerSalesByGoodsExport[k][i]['Количество'] = this.partnerSalesByGoods[k].value[i].КоличествоTurnover
          this.partnerSalesByGoodsExport[k][i]['Sales'] = this.partnerSalesByGoods[k][i].СуммаВыручкиБезНДСTurnover
          for (var j = 0; j < this.goodsInfotronic.length; j++) {
            if (this.goodsInfotronic[j].АналитикаНоменклатуры_Key === this.partnerSalesByGoods[k][i].АналитикаУчетаНоменклатуры_Key) {
              // console.log('found')
              this.partnerSalesByGoodsExport[k][i]['Name'] = this.goodsInfotronic[j].Артикул + ' ' + this.goodsInfotronic[j].Description
              break
            }
          }
        }
      }
    },
    async getPartnerSalesByYearByGroups (partnerAnalyticsKey) {
      console.log('getPartnerSalesByYearByGroups')
      // var date = new Date()
      // var year = date.getFullYear().toString()
      // const response0 = await ApiService.partnerSalesByYearByGroups(this.user.КлючАналитикиПартнера, year)
      // const response1 = await ApiService.partnerSalesByYearByGroups(this.user.КлючАналитикиПартнера, (year - 1))
      // const response2 = await ApiService.partnerSalesByYearByGroups(this.user.КлючАналитикиПартнера, (year - 2))
      this.partnerSalesByGroups[0] = this.partnersSalesByGoods[0]['value'].filter(partner => partner.АналитикаУчетаПоПартнерам_Key === partnerAnalyticsKey)
      this.partnerSalesByGroups[1] = this.partnersSalesByGoods[1]['value'].filter(partner => partner.АналитикаУчетаПоПартнерам_Key === partnerAnalyticsKey)
      this.partnerSalesByGroups[2] = this.partnersSalesByGoods[2]['value'].filter(partner => partner.АналитикаУчетаПоПартнерам_Key === partnerAnalyticsKey)
      // this.partnerSalesByGroups[0] = await response0.data
      // this.partnerSalesByGroups[1] = await response1.data
      // this.partnerSalesByGroups[2] = await response2.data
      var len = []
      len[0] = this.partnerSalesByGroups[0].length
      len[1] = this.partnerSalesByGroups[1].length
      len[2] = this.partnerSalesByGroups[2].length
      // console.log(len[0])
      // console.log(len[1])
      // console.log(len[2])
      // Подготовка массивов
      this.partnerSalesByGroupsExport = []
      for (var k = 0; k < 3; k++) {
        this.partnerSalesByGroupsExport[k] = {}
        for (var j = 0; j < this.goodsInfotronic.length; j++) {
          if (this.goodsInfotronic[j].ТоварнаяКатегория !== 'СПОРТ' && this.goodsInfotronic[j].ТоварнаяКатегория !== 'ПРОЧЕЕ') {
            this.partnerSalesByGroupsExport[k][this.goodsInfotronic[j].ТоварнаяКатегория] = 0
          }
        }
      }
      // Заполнение массивов
      for (k = 0; k < 3; k++) {
        for (var i = 0; i < len[k]; i++) {
          for (j = 0; j < this.goodsInfotronic.length; j++) {
            if (this.goodsInfotronic[j].АналитикаНоменклатуры_Key === this.partnerSalesByGroups[k][i].АналитикаУчетаНоменклатуры_Key) {
              this.partnerSalesByGroupsExport[k][this.goodsInfotronic[j].ТоварнаяКатегория] += Math.round(this.partnerSalesByGroups[k][i].СуммаВыручкиБезНДСTurnover)
            }
          }
        }
      }
    },
    async copyOrderToBasket () {
      console.log('copyOrderToBasket ' + this.goods.length)
      /*
      if (this.goods.length === 0) return
      this.copyPrices()
      this.orders.forEach((order, index) => {
        if (index === this.activeOrder) {
          this.comment = order.Комментарий
          this.orders[index].Товары.forEach((ordergood) => {
            this.goods.forEach((good) => {
              // good.OrderedQty = 0
              if (ordergood.Номенклатура_Key === good.Ref_Key) {
                // console.log(good.НаименованиеПолное)
                good.ВариантОбеспечения = ordergood.ВариантОбеспечения
                good.OrderedQty = 1 * good.OrderedQty
                // console.log('good.OrderedQty' + good.OrderedQty)
                good.OrderedQty += ordergood.Количество
                good.Price = Math.round(ordergood.Цена * 1.2 * 100) / 100
                good.ConfirmedQty = good.OrderedQty
                // console.log(good.OrderedQty)
                // console.log(good.ConfirmedQty)
                this.oi++
                // console.log(good.НаименованиеПолное)
              }
              // if (good.OrderedQty === 0) good.OrderedQty = ''
            })
          })
        }
      })
      if (this.mng) await this.addPartnerSalesShort()
        */
      this.hidebasket = false
      this.loading = false
    },
    async basketUpdate () {
      console.log('basketUpdate')
      /*
      this.orders = []
      this.goods.forEach((good) => {
        good.OrderedQty = ''
        good.ConfirmedQty = 0
      })
      await this.getOrderList()
      await this.copyOrderToBasket()
      */
    },
    async addGood (good) {
      console.log('addGood ' + good)
      var tmp = this.$localStorage.get('order')
      // console.log(tmp)
      if (tmp !== null) {
        this.order = JSON.parse(this.$localStorage.get('order', ''))
        if (good.OrderedQty > 0) {
        // Проверяем, нет ли такого товара в корзине, если есть просто меняем количество
          this.order.forEach((element, index) => {
            if (element.key === good.Ref_Key) {
              this.order.splice(index, 1)
            }
          })
          this.order.push({key: good.Ref_Key, qty: good.OrderedQty})
        }
        if (good.OrderedQty === 0) {
          this.order.forEach((element, index) => {
            if (element.key === good.Ref_Key) {
              this.order.splice(index, 1)
            }
          })
        }
        this.$localStorage.set('order', JSON.stringify(this.order))
      } else {
        var tmparr = []
        tmparr.push({key: good.Ref_Key, qty: good.OrderedQty})
        this.$localStorage.set('order', JSON.stringify(tmparr))
      }
      this.oi = JSON.parse(this.$localStorage.get('order', '')).length
      // console.log('patchOrder ' + event)
      // var orderuid = this.orders[this.activeOrder]['Ref_Key']
      // console.log('orderuid ' + orderuid)
      // var priceType = this.user['ВидЦен_Key']
      // console.log('this.user[ВидЦен_Key] ' + priceType)
      // var goodsQty = this.orderedList.length
      // Проверяем, нет ли такого товара в корзине, если есть просто меняем количество
      /*
      this.orders[this.activeOrder].Товары.forEach((element, index) => {
        if (element.Номенклатура_Key === good.Ref_Key) {
          this.orders[this.activeOrder].Товары.splice(index, 1)
          // console.log('Удалили дубликат')
        }
      })
      // удаляем если количество = 0
      this.orders[this.activeOrder].Товары.forEach((element, index) => {
        if (element.Номенклатура_Key === good.Ref_Key && good.OrderedQty === 0) {
          this.orders[this.activeOrder].Товары.splice(index, 1)
          // console.log('Удалили товар из списка')
        }
      })
      var infotronic = this.goodsInfotronic
      // Проверяем все ли товары из каталога инфотроник ,если нет - создаем товар
      // var ordered = this.orderedList
      var ind = this.orders[this.activeOrder].Товары.length + 1
      var f = false
      var priceVAT = 0
      var sumVAT = 0
      var sum = 0
      var VAT = 0
      var price = 0
      // var jsonString = ''
      // console.log('ind' + ind)
      var qty = infotronic.length
      f = false
      for (var i = 0; i < qty; i++) {
        // console.log(good.Ref_Key + '---' + infotronic[i].Ref_Key)
        if (good.Ref_Key === infotronic[i].Ref_Key) {
          f = true
          // console.log('Нашли ' + infotronic[i].Ref_Key)
          if (good.Price !== 0) priceVAT = good.Price
          else if (good.PriceS !== 0) priceVAT = good.PriceS
          else priceVAT = 5555
          // console.log(' ind ' + ind)
          price = Math.round((priceVAT * 100 / 120) * 100) / 100
          sumVAT = Math.round((priceVAT * good.OrderedQty) * 100) / 100
          sum = Math.round((priceVAT * good.OrderedQty * 100 / 120) * 100) / 100
          VAT = Math.round((sumVAT - sum) * 100) / 100
          if (good.OrderedQty > 0) {
            this.orders[this.activeOrder].Товары.splice(ind, 0, {
              'Ref_Key': orderuid,
              'LineNumber': ind,
              'КодСтроки': ind,
              'Номенклатура_Key': good.Ref_Key,
              'Количество': good.OrderedQty,
              'КоличествоУпаковок': good.OrderedQty,
              'ВариантОбеспечения': 'Требуется',
              'ВидЦены_Key': priceType,
              'Склад_Key': '17631cba-e764-11e5-a13e-00e04d95380f',
              'Цена': price,
              'Сумма': sum,
              'СтавкаНДС': 'НДС20',
              'СуммаНДС': VAT,
              'СуммаСНДС': sumVAT
            })
          }
          break
        }
      }
      if (!f) {
        // console.log('Не наш товар ' + good.Ref_Key)
        const response = await ApiService.createGood(good.Артикул, good.НаименованиеПолное)
        let data = response.data
        // console.log(data)
        // console.log('Новый код:' + data.Ref_Key)
        // меняем коды в справочниках
        qty = this.goods.length
        for (var j = 0; j < qty; j++) {
          if (this.goods[j].Ref_Key === good.Ref_Key) {
            this.goods[j] = good
            break
          }
        }
        qty = this.goodsInfotronic.length
        this.goodsInfotronic.splice(qty, 0, good)
        good.Ref_Key = data.Ref_Key
        if (good.Price !== 0) priceVAT = good.Price
        else if (good.PriceS !== 0) priceVAT = good.PriceS
        else priceVAT = 5555
        // console.log(' В списке на отправку ' + JSON.stringify(element))
        price = Math.round((priceVAT * 100 / 120) * 100) / 100
        sumVAT = Math.round((priceVAT * good.OrderedQty) * 100) / 100
        sum = Math.round((priceVAT * good.OrderedQty * 100 / 120) * 100) / 100
        VAT = Math.round((sumVAT - sum) * 100) / 100
        this.orders[this.activeOrder].Товары.splice(ind, 0, {
          'Ref_Key': orderuid,
          'LineNumber': ind,
          'КодСтроки': ind,
          'Номенклатура_Key': good.Ref_Key,
          'Количество': good.OrderedQty,
          'КоличествоУпаковок': good.OrderedQty,
          'ВариантОбеспечения': 'Требуется',
          'ВидЦены_Key': priceType,
          'Склад_Key': '17631cba-e764-11e5-a13e-00e04d95380f',
          'Цена': price,
          'Сумма': sum,
          'СтавкаНДС': 'НДС20',
          'СуммаНДС': VAT,
          'СуммаСНДС': sumVAT
        })
      }
      this.orders[this.activeOrder].Товары.forEach((element, index) => {
        element.LineNumber = index + 1
        element.КодСтроки = index + 1
        // element.КлючСвязи = index + 1
      })
      this.orders[this.activeOrder].МаксимальныйКодСтроки = this.orders[this.activeOrder]['Товары'].length
      // console.log(this.orders[this.activeOrder]['Товары'].length)
      var dataVersion = this.orders[this.activeOrder]['DataVersion']
      var jsonString = JSON.stringify(this.orders[this.activeOrder].Товары)
      const response = await ApiService.patchOrder(orderuid, jsonString, dataVersion)
      let data = response.data
      // console.log(data)
      */
      good.ConfirmedQty = good.OrderedQty
      // this.orders[this.activeOrder]['DataVersion'] = data.DataVersion
      // this.$emit('orderUpdated')
    }
  },
  beforeMount () {
    this.activeItem = this.$route.matched[0].props.default.page
    // this.ai = 1
  },
  mounted () {
    this.getGoods('')
  },
  computed: {
    activeOrders () {
      return this.orders.length
    }
  },
  mixins: [waves]
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .navbar-light .navbar-brand {
    margin-left: 15px;
    color: #2196f3 !important;
    font-weight: bolder;
    border-radius: 1.5rem;
  }
 .nav-item.active > .nav-link:hover {
    border-radius: 1.5rem;
    background-color: #e9ecef;
  }
  navbar.navbar-light .nav-item.active > .nav-link {
     background-color: #e9ecef;
}
  .btn-call {
    border-radius: 2rem;
    padding: 1rem;
    padding-top: 0.9rem;
    padding-right: 1.1rem;
    padding-bottom: 0.9rem;
    padding-left: 1,1rem;
  }
  main {
    background-color: #EDEDEE;
  }

  .flexible-content {
    transition: padding-left 0.3s;
    padding-left: 270px;
  }

  .flexible-navbar {
    transition: padding-left 0.5s;
    padding-left: 270px;
  }

  .sidebar-fixed {
    left: 0;
    top: 0;
    height: 100vh;
    width: 270px;
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
    z-index: 1050;
    background-color: #fff;
    padding: 1.5rem;
    padding-top: 0;
    overflow-y: auto;
  }

  .sidebar-fixed .logo-wrapper img {
    width: 100%;
    padding: 2.5rem;
  }

  .sidebar-fixed .list-group-item {
    display: block !important;
    transition: background-color 0.3s;
  }

  .sidebar-fixed .list-group .active {
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
    border-radius: 5px;
  }
  .navbar .nav-item .nav-link {
    display: block;
    border-radius: 1.5rem;
}
  @media (max-width: 1000px) {
    .sidebar-fixed {
      display: none;
    }

    .flexible-content {
      padding-left: 0;
    }

    .flexible-navbar {
      padding-left: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue